export enum EmployeeType {
  Employee = 0,
  SalaryAdmin = 1,
  CFO = 2,
}
